import api from "./apiClient";

/* ===================================================== */
/* 🔧 ERROR NORMALIZER                                   */
/* ===================================================== */
function normalizeError(err, fallback) {
  return new Error(
    err?.message ||
    err?.response?.data?.message ||
    fallback
  );
}

/* ===================================================== */
/* 📄 GET ALL CONTRACTS                                  */
/* GET /contracts                                        */
/* ===================================================== */
export const getContracts = async () => {
  try {
    const { data } = await api.get("/contracts");

    // ✅ If backend returns structured object → use directly
    if (
      data &&
      (data.incoming || data.outgoing || data.active || data.rejected)
    ) {
      return data;
    }

    // ✅ Fallback: legacy array response
    if (Array.isArray(data)) {
      return data;
    }

    // ❌ Unexpected response
    console.warn("⚠️ Unexpected contracts response:", data);
    return {
      incoming: [],
      outgoing: [],
      active: [],
      rejected: [],
    };

  } catch (err) {
    throw normalizeError(err, "Failed to fetch contracts");
  }
};
/* ===================================================== */
/* 📤 INVITE COMPANY                                     */
/* POST /contracts/invite                                */
/* ===================================================== */
export const inviteCompany = async (contractorCompanyId) => {
  if (!contractorCompanyId) {
    throw new Error("contractorCompanyId is required");
  }

  try {
    const { data } = await api.post("/contracts/invite", {
      contractorCompanyId,
    });

    return data?.contract;
  } catch (err) {
    throw normalizeError(err, "Failed to send contract invite");
  }
};

/* ===================================================== */
/* ✅ ACCEPT CONTRACT                                    */
/* ===================================================== */
export const acceptContract = async (id) => {
  if (!id) throw new Error("Contract ID required");

  try {
    const { data } = await api.post(`/contracts/${id}/accept`);
    return data?.contract;
  } catch (err) {
    throw normalizeError(err, "Failed to accept contract");
  }
};

/* ===================================================== */
/* ❌ REJECT CONTRACT                                    */
/* ===================================================== */
export const rejectContract = async (id) => {
  if (!id) throw new Error("Contract ID required");

  try {
    await api.post(`/contracts/${id}/reject`);
    return true;
  } catch (err) {
    throw normalizeError(err, "Failed to reject contract");
  }
};

/* ===================================================== */
/* 🗑 DELETE CONTRACT                                    */
/* ===================================================== */
export const deleteContract = async (id) => {
  if (!id) throw new Error("Contract ID required");

  try {
    await api.delete(`/contracts/${id}`);
    return true;
  } catch (err) {
    throw normalizeError(err, "Failed to delete contract");
  }
};

export default {
  getContracts,
  inviteCompany,
  acceptContract,
  rejectContract,
  deleteContract,
};